import React from 'react';
import CIcon from '@coreui/icons-react';
import {
  cilSun,
  cilDollar,
  cilChartPie,
  cilMap,
  cilBorderAll,
  cilBrowser,
  cilApple,
  cilGraph,
  cilChartLine,
  cilRecycle,
  cilCalculator,
} from '@coreui/icons';
import {
  CNavItem,
  CNavTitle,
} from '@coreui/react-pro';

const PrivateNavigation = [
  {
    component: CNavTitle,
    name: 'Market Information',
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Cash Bids',
    to: 'cash-bids',
    icon: <CIcon icon={cilDollar} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Marketing Plan',
    to: 'marketing-plan',
    icon: <CIcon icon={cilChartLine} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavTitle,
    name: 'Weather',
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Weather Stations',
    to: 'weather-stations',
    icon: <CIcon icon={cilSun} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavTitle,
    name: 'Reports',
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Reports',
    to: 'reports',
    icon: <CIcon icon={cilChartPie} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavTitle,
    name: 'Mapping',
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'My Fields',
    to: 'mapping/my-fields',
    icon: <CIcon icon={cilMap} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: true,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Map My Fields',
    to: 'mapping/map-my-fields',
    icon: <CIcon icon={cilBorderAll} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Net Of Freight',
    to: 'mapping/net-of-freight',
    icon: <CIcon icon={cilGraph} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavTitle,
    name: 'Agronomy',
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Nutrient Removal',
    to: 'mapping/nutrient-removal',
    icon: <CIcon icon={cilRecycle} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Fertilizer vs. Corn Futures',
    to: 'agronomy/fertilizer-vs-corn-futures',
    icon: <CIcon icon={cilChartLine} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavTitle,
    name: 'Tool Box',
    yieldEstimatorOnly: true,
  },
  {
    component: CNavItem,
    name: 'Phantom Yield Loss Calculator',
    to: 'tool-box/phantom-yield-loss-calculator',
    icon: <CIcon icon={cilCalculator} customClassName='nav-icon' style={{ paddingBottom: 2, }} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Yield Estimator',
    to: 'tool-box/yield-estimator',
    icon: <CIcon icon={cilCalculator} customClassName='nav-icon' style={{ paddingBottom: 2, }} />,
    employeeRestricted: false,
    yieldEstimatorOnly: true,
  },
  {
    component: CNavItem,
    name: 'Carbon Scoring',
    to: 'tool-box/carbon-scoring',
    icon: <CIcon icon={cilCalculator} customClassName='nav-icon' style={{ paddingBottom: 2, }} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavTitle,
    name: 'Support & Help',
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Browser Check',
    to: 'support/browser-check',
    icon: <CIcon icon={cilBrowser} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
  {
    component: CNavItem,
    name: 'Apple Requirements',
    to: 'support/apple-requirements',
    icon: <CIcon icon={cilApple} customClassName='nav-icon' style={{paddingBottom: 2,}} />,
    employeeRestricted: false,
    yieldEstimatorOnly: false,
  },
]

export default PrivateNavigation;
